module.exports = __webpack_public_path__ + "static/media/iStock-1243760572.4c7c8edd.jpg";